// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__hvvIY","list":"PatternAutocomplete_list__3xsZF"};